import { InfoOutlinedIcon } from "@l2r-front/l2r-icons"
import {
    styled,
    KpiCard as UiKpiCard,
    KpiError as KpiErrorUi,
    KpiSkeleton as KpiSkeletonUi,
    Tooltip as UiTooltip,
    Typography,
} from "@l2r-front/l2r-ui"

export const KpiCard = styled(UiKpiCard)({
    justifyContent: "flex-start",
    "-webkit-user-drag": "none",
})

export const KpiSkeleton = styled(KpiSkeletonUi)(() => ({
    width: "100%",
    height: "100%",
}))

export const KpiError = styled(KpiErrorUi)(() => ({
    width: "100%",
    height: "100%",
}))

export const Header = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
    width: "100%",
    flex: "0 0 auto",
}))

export const Title = styled(Typography)(({ theme }) => ({
    color: theme.palette["objects/object-black"].main,
}))

export const Tooltip = styled(UiTooltip)(() => ({
}))

export const InfoIcon = styled(InfoOutlinedIcon)(({ theme }) => ({
    color: theme.palette.primary.main,
    height: 24,
}))

export const Desc = styled(Typography)(({ theme }) => ({
    color: theme.palette["objects/object-black"].main,
    marginBottom: theme.spacing(2),
    width: "100%",
    textAlign: "left",
}))

export const ChartContainer = styled("div")(() => ({
    width: "100%",
    flex: "1 1 auto",
}))